export default function BrandStory() {
  const exteriors = [
    {
      src: 'https://static.readdy.ai/image/30f27ef602d0090e19be279ddf894f7d/d355ba8c4aa239b21153119220566948.jpeg',
      alt: 'GIAZO アスタ住宅展示場 外観',
    },
    {
      src: 'https://static.readdy.ai/image/30f27ef602d0090e19be279ddf894f7d/0e01bc3675087cc62f199efcdfa0bec0.jpeg',
      alt: 'GIAZO 東広島ハウジングフェア展示場 外観',
    },
    {
      src: 'https://static.readdy.ai/image/30f27ef602d0090e19be279ddf894f7d/6321a12020a4f822ece781ae975853a9.jpeg',
      alt: 'GIAZO 住宅宣言ふくやま広島テレビ展示場 外観',
    },
    {
      src: 'https://storage.readdy-site.link/project_files/08d9908a-2395-4ac3-82a1-6049451d0d9d/57deb3f4-c999-489b-bf78-01246c84c60e_compressed_GIAZO.webp',
      alt: 'GIAZO ふれあいホームタウンおのみち 外観',
    },
  ];

  return (
    <section id="brand-story" className="relative w-full bg-background-50 py-28 md:py-40">
      <div className="w-full px-6 md:px-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          {/* Left: Text */}
          <div className="w-full lg:w-[45%]">
            <p className="font-sans text-[12px] tracking-[0.2em] text-foreground-400 mb-10">
              BRAND STORY / 01
            </p>

            <h2
              className="font-heading text-[24px] md:text-[32px] tracking-[0.1em] leading-[1.8] text-foreground-950 mb-10"
              style={{ fontWeight: 300 }}
            >
              格式ある空間と、
              <br />
              上質な広がりを体感する。
            </h2>

            <p
              className="font-sans text-[15px] md:text-[16px] tracking-[0.04em] leading-[2.4] text-foreground-600 mb-16"
              style={{ fontWeight: 300 }}
            >
              創建ホームが提案するデザインシリーズ
              <strong className="text-foreground-950" style={{ fontWeight: 400 }}>
                「GIAZO」
              </strong>
              。ただ家を建てるだけでなく、そこで過ごす豊かな時間をデザインします。モデルハウスでは、間取りのご見学はもちろん、お客様の理想の注文住宅についてのご相談も承ります。
            </p>

            {/* 01 02 03 Points */}
            <div className="flex flex-wrap gap-10">
              <div>
                <p
                  className="font-sans text-[28px] md:text-[32px] tracking-[0.05em] text-foreground-300 mb-2"
                  style={{ fontWeight: 300 }}
                >
                  01
                </p>
                <p
                  className="font-sans text-[12px] tracking-[0.15em] text-foreground-700 mb-1"
                  style={{ fontWeight: 400 }}
                >
                  PREMIUM SPACE
                </p>
                <p
                  className="font-sans text-[13px] tracking-[0.05em] text-foreground-400"
                  style={{ fontWeight: 300 }}
                >
                  創建ホームならではの
                  <br />
                  上質な空間
                </p>
              </div>
              <div>
                <p
                  className="font-sans text-[28px] md:text-[32px] tracking-[0.05em] text-foreground-300 mb-2"
                  style={{ fontWeight: 300 }}
                >
                  02
                </p>
                <p
                  className="font-sans text-[12px] tracking-[0.15em] text-foreground-700 mb-1"
                  style={{ fontWeight: 400 }}
                >
                  CUSTOM PLAN
                </p>
                <p
                  className="font-sans text-[13px] tracking-[0.05em] text-foreground-400"
                  style={{ fontWeight: 300 }}
                >
                  理想の暮らしを叶える
                  <br />
                  注文住宅のご相談
                </p>
              </div>
              <div>
                <p
                  className="font-sans text-[28px] md:text-[32px] tracking-[0.05em] text-foreground-300 mb-2"
                  style={{ fontWeight: 300 }}
                >
                  03
                </p>
                <p
                  className="font-sans text-[12px] tracking-[0.15em] text-foreground-700 mb-1"
                  style={{ fontWeight: 400 }}
                >
                  TIME DESIGN
                </p>
                <p
                  className="font-sans text-[13px] tracking-[0.05em] text-foreground-400"
                  style={{ fontWeight: 300 }}
                >
                  豊かな時間をデザイン
                  <br />
                  する住まい
                </p>
              </div>
            </div>
          </div>

          {/* Right: 4 Exterior Images Grid */}
          <div className="w-full lg:w-[55%]">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {exteriors.map((img) => (
                <div key={img.alt} className="w-full" style={{ aspectRatio: '4/3' }}>
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}